import { render, staticRenderFns } from "./ApmsRegLaborEmployment.vue?vue&type=template&id=494f7af8&scoped=true&"
import script from "./ApmsRegLaborEmployment.vue?vue&type=script&lang=js&"
export * from "./ApmsRegLaborEmployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494f7af8",
  null
  
)

export default component.exports